import { render, staticRenderFns } from "./index.vue?vue&type=template&id=6bcf80ac&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=6bcf80ac&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bcf80ac",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zkdn_workspace\\zhijiao\\bjzyjy-mhwz\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6bcf80ac')) {
      api.createRecord('6bcf80ac', component.options)
    } else {
      api.reload('6bcf80ac', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=6bcf80ac&scoped=true", function () {
      api.rerender('6bcf80ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/login/international/courses/index.vue"
export default component.exports